import { Duck } from './Duck';
import type { MascotName } from '../theme/ThemeProvider';

type Props = {
  mascot: MascotName;
};

const COLUMNS: { title: string; items: string[] }[] = [
  { title: 'Show', items: ['Episodes', 'Roadmap', 'Topics', 'Archive'] },
  { title: 'Take part', items: ['Be a panelist', 'Submit a topic', 'Sponsor', 'Bring a duck'] },
  { title: 'Elsewhere', items: ['Newsletter', 'YouTube', 'RSS', 'Contact'] },
];

export function Footer({ mascot }: Props): JSX.Element {
  return (
    <footer className="grid gap-8 border-t-2 border-ink bg-bg px-8 pt-10 pb-6" style={{ gridTemplateColumns: '1.2fr 1fr 1fr 1fr' }}>
      <div>
        <div className="mb-2.5 flex items-center gap-2.5">
          <Duck variant={mascot} size={36} />
          <div className="font-display text-lg font-extrabold text-ink">The Rubber Duck Debate</div>
        </div>
        <div className="max-w-[280px] text-[13px] text-ink-soft">
          A semi-live debate series where humans and bots argue about AI in software. May the loudest quack win.
        </div>
      </div>
      {COLUMNS.map((col) => (
        <div key={col.title}>
          <div className="mb-2.5 font-mono text-[11px] uppercase tracking-[0.1em] text-ink-soft">{col.title}</div>
          <div className="flex flex-col gap-1.5">
            {col.items.map((item) => (
              <a key={item} href="#" className="text-sm font-medium text-ink no-underline">
                {item}
              </a>
            ))}
          </div>
        </div>
      ))}
      <div className="col-span-full flex justify-between border-t border-[rgb(var(--color-ink)/12%)] pt-4 font-mono text-[11px] text-ink-soft">
        <span>© 2026 Rubber Duck Industries · No ducks were debugged in the making of this website.</span>
        <span>v0.1.0-quack</span>
      </div>
    </footer>
  );
}
